'use strict';

exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var SliderButton = (function (_Component) {
  _inherits(SliderButton, _Component);

  function SliderButton() {
    var _this = this;

    _classCallCheck(this, SliderButton);

    _Component.apply(this, arguments);

    this.renderPauseButton = function () {
      return _react2['default'].createElement(
        'a',
        { onClick: _this.props.onClick, style: { flex: 1 } },
        _react2['default'].createElement(
          'svg',
          { viewBox: '0 0 24 24', preserveAspectRatio: 'xMidYMid meet',
            style: _this.iconStyle(_this.props.theme)
          },
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', { d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z' })
          )
        )
      );
    };

    this.renderStepButton = function (direction) {
      var d = direction === 'left' ? 'M15.41 16.09l-4.58-4.59 4.58-4.59-1.41-1.41-6 6 6 6z' : 'M8.59 16.34l4.58-4.59-4.58-4.59 1.41-1.41 6 6-6 6z';

      return _react2['default'].createElement(
        'a',
        { onClick: _this.props.onClick, style: { flex: 1 } },
        _react2['default'].createElement(
          'svg',
          { viewBox: '0 0 24 24', preserveAspectRatio: 'xMidYMid meet',
            style: _this.iconStyle(_this.props.theme)
          },
          _react2['default'].createElement(
            'g',
            null,
            _react2['default'].createElement('path', { d: d })
          )
        )
      );
    };

    this.renderPlaybackSpeedButton = function () {
      var style = {
        cursor: 'hand',
        color: _this.props.theme.base06,
        fontSize: _this.props.replaySpeed === 'Live' ? '1.1em' : '1.8em',
        flex: 1
      };

      return _react2['default'].createElement(
        'div',
        { style: style, onClick: _this.props.onClick },
        _this.props.replaySpeed
      );
    };
  }

  SliderButton.prototype.iconStyle = function iconStyle(theme) {
    return {
      cursor: 'hand',
      fill: theme.base06,
      width: '2.3rem',
      height: '2.3rem'
    };
  };

  SliderButton.prototype.renderPlayButton = function renderPlayButton() {
    return _react2['default'].createElement(
      'a',
      { onClick: this.props.onClick, style: { flex: 1 } },
      _react2['default'].createElement(
        'svg',
        { viewBox: '0 0 24 24', preserveAspectRatio: 'xMidYMid meet',
          style: this.iconStyle(this.props.theme)
        },
        _react2['default'].createElement(
          'g',
          null,
          _react2['default'].createElement('path', { d: 'M8 5v14l11-7z' })
        )
      )
    );
  };

  SliderButton.prototype.render = function render() {
    switch (this.props.type) {
      case 'play':
        return this.renderPlayButton();
      case 'pause':
        return this.renderPauseButton();
      case 'stepLeft':
        return this.renderStepButton('left');
      case 'stepRight':
        return this.renderStepButton('right');
      case 'playBackSpeed':
        return this.renderPlaybackSpeedButton();
      default:
        return null;
    }
  };

  _createClass(SliderButton, null, [{
    key: 'propTypes',
    value: {
      theme: _react.PropTypes.object,
      replaySpeed: _react.PropTypes.string,
      type: _react.PropTypes.string,
      onClick: _react.PropTypes.func
    },
    enumerable: true
  }]);

  return SliderButton;
})(_react.Component);

exports['default'] = SliderButton;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-slider-monitor/lib/SliderButton.js
 ** module id = 977
 ** module chunks = 0
 **/